import { constants } from "../constants";

export const setUserResetEmail = userResetEmail => dispatch => {
  dispatch({
    type: constants.SET_USER_RESET_EMAIL,
    payload: { userResetEmail }
  });
};
